import { h, defineComponent } from 'vue';
import * as Icons from '@ant-design/icons-vue';

const toPascalCase = type => type
	.split('-')
	.map(s => s.charAt(0).toUpperCase() + s.slice(1))
	.join('');

function getSuffix(theme) {
	if (theme === 'filled') return 'Filled';
	if (theme === 'twoTone') return 'TwoTone';
	return 'Outlined';
}

export default defineComponent({
	name: 'AIcon',
	props: {
		type: { type: String, default: '' },
		theme: { type: String, default: 'outlined' },
	},
	render() {
		const { type, theme } = this;
		if (!type) return null;

		const pascal = toPascalCase(type);
		const suffix = getSuffix(theme);
		const name = `${pascal}${suffix}`;

		const IconComponent = Icons[name] || Icons[`${pascal}Outlined`] || null;
		if (!IconComponent) {
			if (process.env.NODE_ENV !== 'production') {
				// eslint-disable-next-line no-console
				console.warn(`[AIcon] Unknown icon type: "${type}"`);
			}
			return null;
		}

		return h(IconComponent, { class: this.$attrs.class, style: this.$attrs.style });
	},
});
